import type DefaultError from "@ext/errorHandlers/logic/DefaultError";
import type FetchResponse from "./Types/FetchResponse";

/**
 * The error a failed command answered with. Fetchers differ in where they leave it: the in-process
 * ones (web, tauri) carry the object on the response, a real `fetch` keeps it in the body — and that
 * body may already have been read, so parsing it again is allowed to fail.
 */
const readResponseError = async (response: FetchResponse): Promise<DefaultError | undefined> => {
	const carried = response as FetchResponse & { error?: DefaultError; body?: DefaultError };
	const error = carried.error ?? carried.body;
	if (error) return error;

	try {
		return await response.json();
	} catch {
		return undefined;
	}
};

export default readResponseError;
